<template>
  <div>
    <FormFilter :submit-filter="submitFilter">
      <b-col v-for="(item, index) of fieldFilter" :key="index" cols="4">
        <b-form-group :label="item.label" :label-for="item.id">
          <b-form-select :id="item.id" :value="item.model" :options="item.options"
            :disabled="!$can('Filter', 'b-ruangan') || item.isDisabled" @change="item.change" />
        </b-form-group>
      </b-col>
      <b-col cols="4">
        <b-form-group label="PD/UKPD" label-for="pdUkpdFilter">
          <v-select id="kolok" v-model="pdUpdFilterValue" label="text" :options="dataPdUpd"
            :disabled="!$can('Filter', 'b-ruangan') || isDisablePdUpd" @input="inputPdUpd" />
        </b-form-group>
      </b-col>
    </FormFilter>
    <b-card no-body>
      <b-card-header>
        <b-card-title>Data</b-card-title>
        <div v-if="!isFinal">
          <b-card-title v-if="$can('Buat', 'b-ruangan') && isValidatedSkTimForInput && closeSistemInformation.isOpen"
            class="text-primary">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" :to="{ name: 'bRuanganInput' }">
              <feather-icon icon="PlusIcon" class="mr-50" />
              <span class="align-middle">Input</span>
            </b-button>
          </b-card-title>
        </div>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col cols="12" class="mt-2">
            <b-alert v-if="!isValidatedSkTim" variant="warning" show class="text-center">
              <div class="alert-body">
                <span><strong>Peringatan</strong></span>
                <feather-icon icon="InfoIcon" class="mr-50" />
                <p>Proses ruangan tidak dapat dilakukan sebelum <strong>SK TIM</strong> diunggah</p>
              </div>
            </b-alert>
            <!-- search input -->
            <div class="custom-search d-flex justify-content-between mb-1">
              <div>
                <b-button v-if="dataSelectedRows.length > 0 && $can('Print', 'b-ruangan')"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="clickPrint">
                  <div v-if="isPrintQr">
                    <b-spinner small />
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div v-else>
                    Print QR ({{ dataSelectedRows.length }})
                  </div>
                </b-button>
                <b-dropdown v-if="isValidatedSkTimForInput" v-ripple.400="'rgba(113, 102, 240, 0.15)'" right
                  variant="primary" text="Print" class="ml-1">
                  <b-dropdown-item @click="clickPrintTable('excel')">
                    Excel
                  </b-dropdown-item>
                  <b-dropdown-item @click="clickPrintTable('pdf')">
                    PDF
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <b-input-group>
                <b-input-group-prepend>
                  <v-select id="searchOpt" class="search-filter-option-select" v-model="keyCari" label="text"
                    :options="searchOptions" />
                </b-input-group-prepend>
                <b-form-input id="Kata" v-model="searchTerm"
                  placeholder="Pencarian data BMD, pilih kata kunci pencarian lalu tekan enter" type="text"
                  class="d-inline-block" @keyup.enter="handleSearch" />
              </b-input-group>
              <!-- <b-form-group>
                <div class="d-flex align-items-center">
                  <label class="mr-1">Cari</label>
                  <b-form-input v-model="searchTerm" placeholder="Tekan Enter" type="text" class="d-inline-block"
                    @keyup.enter="handleSearch" />
                </div>
              </b-form-group> -->
            </div>
            <!-- table -->
            <vue-good-table :columns="columns" :rows="rows" :search-options="{
              enabled: true,
              externalQuery: searchTerm,
            }" :pagination-options="{
  enabled: true,
  perPage: row,
  jumpFirstOrLast: true,
}" :total-rows="totalRecords" :is-loading="isLoading" mode="remote" :select-options="{
  enabled: true,
  selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
  selectionInfoClass: 'custom-class',
  selectionText: 'rows selected',
  clearSelectionText: 'clear',
  disableSelectInfo: true, // disable the select info panel on top
  selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
}" @on-sort-change="onSortChange" @on-selected-rows-change="selectionChangedTable">
              <template slot="table-row" slot-scope="props">
                <!-- Column: aksi -->
                <span v-if="props.column.field === 'aksi'">
                  <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                    <template v-slot:button-content>
                      <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                    </template>
                    <div v-for="(item, index) of getAksi(props.row)" :key="index">
                      <b-dropdown-item v-if="item.to" :to="item.to">
                        <feather-icon :icon="item.icon" class="mr-50" />
                        <span>{{ item.buttonLabel }}</span>
                      </b-dropdown-item>
                      <b-dropdown-item v-else @click="item.clickAksi({
                        idRuangan: props.row.id,
                        idJenisRuangan: props.row.jenis_ruangan_id,
                        namaJenisRuangan: props.row.jenis_ruangan_nama,
                        namaRuangan: props.row.nama_ruangan,
                        lantai: props.row.lantai,
                        kolok: props.row.kolok,
                        kolok_gedung: props.row.kolok_gedung
                      })">
                        <feather-icon :icon="item.icon" class="mr-50" />
                        <span>{{ item.buttonLabel }}</span>
                      </b-dropdown-item>
                    </div>
                  </b-dropdown>
                </span>

                <!-- Column: Common -->
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>

              <!-- pagination -->
              <template slot="pagination-bottom">
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> Menampilkan 1 hingga </span>
                    <b-form-select v-model="row" :options="['10', '25', '50']" class="mx-1" @input="handlePageChange" />
                    <span class="text-nowrap">
                      dari {{ totalRecords }} entri
                    </span>
                  </div>
                  <div>
                    <b-pagination :value="1" :total-rows="totalRecords" :per-page="row" first-number last-number
                      align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0"
                      @change="handleChangePage">
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </div>
                </div>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <ModalRuangan :props-modal="{ modal, lantaiOptions, ruangan, kolok, inputLantai: datatable }" />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormInput,
  BDropdown,
  BDropdownItem,
  BPagination,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BFormGroup,
  BFormSelect,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import { ref, computed } from '@vue/composition-api'
import moment from 'moment'
import vSelect from 'vue-select'
import {
  generateYears, startYear, showError, defaultValue,
} from '@/libs/helper'
import apiMaster from '@/composables/master/masterBRef'
import apiRuangan from '@/composables/b/ruangan'
import FormFilter from '@/components/form/FormFilter'
import ModalRuangan from '@/views/b/ruangan/components/ModalRuangan.vue'
import searchOpt from "@/composables/b/searchOpt";
import { closeSistemKibB } from '@/libs/helper';

export default {
  setup(props, context) {
    // global variable
    const g = context.root
    const { $route } = g

    const year = moment().format('YYYY')

    const tahunFilter = ref(year)
    const wilayahFilter = ref($route.query.wilayah || '')
    const pdUpdFilter = ref($route.query['pd-ukpd'] || '')
    const pdUpdFilterValue = ref({ text: '-- Semua --', value: '' })
    const modal = ref({
      toggle: false,
      action: 'Tambah',
    })
    const kolok = ref(null)

    const cookiesJenisAkun = ref(g.$cookies.get('jenisAkun'))

    if (cookiesJenisAkun.value == 'D' || cookiesJenisAkun.value == 'F' || cookiesJenisAkun.value == 'A') {
      const cookiesNalok = ref(g.$cookies.get('nalok'))
      const cookiesKolok = ref(g.$cookies.get('kolok'))
      const cookiesWilayah = ref(g.$cookies.get('wilayah'))

      pdUpdFilterValue.value = {
        text: `${cookiesKolok.value}::${cookiesNalok.value}`,
        value: cookiesKolok.value,
      }
      pdUpdFilter.value = cookiesKolok.value
      wilayahFilter.value = cookiesWilayah.value
    } else if (cookiesJenisAkun.value == 'pelaksana-suban') {
      wilayahFilter.value = parseInt(g.$cookies.get('wilayah'), 10)
    }
    let tempListYear = [{
      text: '--Pilih Salah Satu--',
      value: '',
    }]
    if (g.$cookies.get('listTahun')) {
      const listTahun = JSON.parse(g.$cookies.get('listTahun'))
      tempListYear = [...tempListYear, ...listTahun.map(item => ({ ...item, value: item.tahun_rekon, text: item.tahun_pelaksanaan }))]
      tahunFilter.value = $route.query.tahun || tempListYear[tempListYear.length - 1].value
    } else {
      tempListYear = [...tempListYear, ...generateYears(startYear, year)]
      tahunFilter.value = $route.query.tahun || tempListYear[tempListYear.length - 1].value
    }

    const dataTahun = ref(tempListYear)
    const dataPdUpd = ref([{ text: '-- Semua --', value: '' }])
    const dataWilayah = ref([])
    const lantaiOptions = ref([defaultValue])
    const ruangan = ref({
      lantai: null,
      jenisRuangan: defaultValue,
      namaRuangan: '',
      idRuangan: null,
    })

    // variable untuk table
    const rows = ref([])
    const searchTerm = ref('');
    const keyCari = ref(
      { text: '-- Pilih Key --', value: '' }
    );
    const start = ref(1)
    const row = ref(10)
    const totalRecords = ref(0)
    const sortColumn = ref('')
    const order = ref('')
    const dataSelectedRows = ref([])
    const isLoading = ref(false)
    const isDisablePdUpd = ref(true)
    const isPrintQr = ref(false)
    const isPrint = ref(false)
    const isValidatedSkTim = ref(true)
    const isValidatedSkTimForInput = ref(false)

    const getPdUpd = async (searchPdUpd = '') => {
      const params = {
        tahun: tahunFilter.value,
        cari: searchPdUpd,
        wilayah: wilayahFilter.value,
      }
      const resPdUpd = await apiMaster.getKolokDs(g, params)

      const index = resPdUpd.rows.findIndex(item => item.value == pdUpdFilter.value)
      if (index >= 0) {
        isDisablePdUpd.value = false
        pdUpdFilterValue.value = {
          text: resPdUpd.rows[index].text,
          value: resPdUpd.rows[index].value,
        }
      }

      resPdUpd.rows.unshift({ text: '-- Semua --', value: '' })
      dataPdUpd.value = resPdUpd.rows
    }

    // watch(dataPdUpd, () => {
    //   if ($route.query['pd-upd'] && dataPdUpd.value.length > 1) {
    //     const index = dataPdUpd.value.findIndex(item => item.value == $route.query['pd-ukpd'])
    //     pdUpdFilterValue.value = dataPdUpd.value[index]
    //   }
    // })

    const fieldFilter = computed(() => ([
      {
        label: 'Tahun',
        id: 'tahunFilter',
        model: tahunFilter.value,
        isDisabled: true,
        options: dataTahun.value,
        change: e => {
          tahunFilter.value = e
        },
      },
      {
        label: 'Wilayah',
        id: 'wilayahFilter',
        model: wilayahFilter.value,
        options: dataWilayah.value,
        change: async e => {
          wilayahFilter.value = e
          pdUpdFilterValue.value = { text: '-- Semua --', value: '' }
          pdUpdFilter.value = ''

          if (e) {
            await getPdUpd()
            isDisablePdUpd.value = false
          } else {
            isDisablePdUpd.value = true
          }
        },
      },
    ]))

    // fungsi ambil data untuk table
    const isFinal = ref(false);
    const datatable = async () => {
      isLoading.value = true

      const params = {
        filter_kolok: pdUpdFilter.value,
        limit: row.value,
        start: start.value - 1,
        cari: searchTerm.value,
        key_cari: (keyCari.value) ? keyCari.value.value : '',
        // username: g.$cookies.get('username'),
      }
      const result = await apiRuangan.getRuangan(g, params)
      const {
        code, rows: dataTable, totalRows, statusSkTim, is_final
      } = result

      if (code == 200) {
        if (dataTable) rows.value = dataTable
        totalRecords.value = totalRows
      } else {
        rows.value = []
        totalRecords.value = 0
      }
      isValidatedSkTim.value = statusSkTim === true
      isValidatedSkTimForInput.value = statusSkTim === true
      isFinal.value = Boolean(Number(is_final));
      isLoading.value = false
    }

    datatable()

    const submitFilter = () => {
      const url = `?tahun=${tahunFilter.value}&wilayah=${wilayahFilter.value}&pd-ukpd=${pdUpdFilter.value}`
      window.history.pushState('', '', url)
      start.value = 1
      datatable()
    }

    const handleSearch = () => {
      start.value = 1
      datatable()
    }

    const handlePageChange = () => {
      start.value = 1
      datatable()
    }

    const handleChangePage = page => {
      start.value = (page - 1) * row.value + 1
      datatable()
    }

    const onSortChange = params => {
      sortColumn.value = params[0].field
      order.value = params[0].type
      datatable()
    }

    const getWilayah = async () => {
      const resWilayah = await apiMaster.getWilayah(g)
      resWilayah.rows.unshift({ text: '-- Semua --', value: '' })

      dataWilayah.value = resWilayah.rows
    }

    const inputPdUpd = () => {
      if (pdUpdFilterValue.value) pdUpdFilter.value = pdUpdFilterValue.value.value
    }

    const selectionChangedTable = data => {
      dataSelectedRows.value = data.selectedRows
    }

    const clickPrint = async () => {
      isPrintQr.value = true

      const listId = []

      for (let i = 0; i < dataSelectedRows.value.length; i += 1) {
        listId.push(dataSelectedRows.value[i].id)
      }

      const data = {
        ruangan_id: listId,
      }

      const pdfFile = await apiRuangan.printQrCode(g, data)
      if (pdfFile) window.open(URL.createObjectURL(pdfFile), '_blank')
      isPrintQr.value = false
    }

    const clickPrintTable = async format => {
      try {
        isPrint.value = true

        window.open(
          `https://jakaset.jakarta.go.id/${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna-b/ruang/daftar-ruang?kolok=${pdUpdFilter.value}&format=${format}`,
          '_blank',
        )
      } catch (error) {
        console.log(error)
        showError(g, { request: error.toString() }, `Gagal print ${format}`)
      }

      isPrint.value = false
    }

    getWilayah()

    const openModal = ({
      idRuangan = null, idJenisRuangan, namaJenisRuangan, namaRuangan = '', action = 'Tambah', lantai, kolok: kolokVal,
    }) => {
      ruangan.value = {
        lantai,
        jenisRuangan: {
          text: namaJenisRuangan,
          value: idJenisRuangan,
        },
        namaRuangan,
        idRuangan,
      }
      kolok.value = kolokVal
      modal.value = {
        action, toggleModal: !modal.value.toggleModal,
      }
    }

    const hapusRuangan = ({ idRuangan, kolok: kolokVal }) => {
      g.$swal({
        title: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya hapus',
        cancelButtonText: 'Batal',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async res => {
        if (res.value) {
          const result = await apiRuangan.deleteRuangan(g, { ruangan_id: idRuangan, kolok: kolokVal })
          if (result.isSuccess) datatable()
        }
      })
    }

    /* Search Option */
    const searchOptions = ref([]);
    const getSearchOptions = () => {
      searchOpt.getSearchOpt(g, { list: 'ruang' }).then(resp => {
        if (resp.success) {
          searchOptions.value = resp.rows
        } else {
        }
        searchOptions.value.unshift({ text: '-- Pilih Key --', value: '' })

      }).catch(err => {
        console.log(err)
      })
    };
    getSearchOptions();

    const closeSistemInformation = ref({});
    setInterval(() => {
      closeSistemInformation.value = closeSistemKibB();
    }, 1000);
    return {
      isDisablePdUpd,
      isPrintQr,
      isValidatedSkTim,
      isValidatedSkTimForInput,

      fieldFilter,
      datatable,
      handleSearch,
      handlePageChange,
      handleChangePage,
      onSortChange,
      submitFilter,
      rows,
      searchTerm,
      start,
      row,
      totalRecords,
      sortColumn,
      order,
      isLoading,
      tahunFilter,
      pdUpdFilterValue,
      pdUpdFilter,
      dataTahun,
      dataPdUpd,
      dataWilayah,
      dataSelectedRows,
      modal,
      lantaiOptions,
      ruangan,
      kolok,

      inputPdUpd,
      selectionChangedTable,
      clickPrint,
      clickPrintTable,
      openModal,
      hapusRuangan,

      searchOptions,
      keyCari,
      closeSistemInformation,
      isFinal
    }
  },
  components: {
    ModalRuangan,
    VueGoodTable,
    BRow,
    BCol,
    BCard,
    BFormInput,
    BDropdown,
    BDropdownItem,
    BPagination,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BFormGroup,
    BFormSelect,
    FormFilter,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      columns: [
        {
          label: 'Aksi',
          field: 'aksi',
          width: '1%',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Kode QR',
          field: 'kode_qr',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Guid ID',
          field: 'guid_aset',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Kolok',
          field: 'kolok_gedung',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Alamat Register',
          field: 'alamat',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Kode Barang',
          field: 'kobar_108',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Nama Barang',
          field: 'nabar_108',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Nama Spesifikasi Barang',
          field: 'nm_spesifikasi_barang',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Lantai',
          field: 'lantai',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Jenis Ruangan',
          field: 'jenis_ruangan_nama',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Ruangan',
          field: 'nama_ruangan',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
      ],
    }
  },
  methods: {
    getAksi({ guid_aset, kolok, kolok_gedung }) {
      const listAksi = [
        {
          to: { name: 'bRuanganDetail', params: { guidAset: guid_aset, kolok, kolok_gedung: kolok_gedung } },
          buttonLabel: 'Detail',
          icon: 'EyeIcon',
        },
      ]

      if (this.$can('Hapus', 'b-ruangan') && this.closeSistemInformation.isOpen && !this.isFinal) {
        listAksi.unshift({
          clickAksi: payload => {
            this.hapusRuangan({ idRuangan: payload.idRuangan, kolok: payload.kolok })
          },
          buttonLabel: 'Hapus',
          icon: 'TrashIcon',
        })
      }

      if (this.$can('Ubah', 'b-ruangan') && this.closeSistemInformation.isOpen && !this.isFinal) {
        listAksi.unshift({
          clickAksi: payload => {
            this.openModal({ ...payload, action: 'Ubah' })
          },
          buttonLabel: 'Update',
          icon: 'Edit2Icon',
        })
      }

      return listAksi
    },
  },
}
</script>

<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
